import DestroyFormCompletelyGQL from '@/lib/api/graphql/DestroyFormCompletely.graphql'
import RestoreFormGQL from '@/lib/api/graphql/RestoreForm.graphql'
import apolloClient from './apolloClient'
import GetTrashedFormsGQL from './graphql/GetTrashedForms.graphql'

import type {
  DestroyFormCompletelyMutation,
  DestroyFormCompletelyMutationVariables,
  GetTrashedFormsQuery,
  GetTrashedFormsQueryVariables,
  RestoreFormMutation,
  RestoreFormMutationVariables,
} from '@/typings/domain'

export function fetchTrashedForms(params: GetTrashedFormsQueryVariables) {
  return apolloClient.query<GetTrashedFormsQuery, GetTrashedFormsQueryVariables>({
    query: GetTrashedFormsGQL,
    variables: params,
    fetchPolicy: 'no-cache',
  })
}

export function restoreForm(input: RestoreFormMutationVariables['input']) {
  return apolloClient.mutate<RestoreFormMutation, RestoreFormMutationVariables>({
    mutation: RestoreFormGQL,
    variables: { input },
    fetchPolicy: 'no-cache',
  })
}

export function destroyFormCompletely(input: DestroyFormCompletelyMutationVariables['input']) {
  return apolloClient.mutate<DestroyFormCompletelyMutation, DestroyFormCompletelyMutationVariables>({
    mutation: DestroyFormCompletelyGQL,
    variables: { input },
    fetchPolicy: 'no-cache',
  })
}
